import * as React from 'react';
import { Spinner } from 'react-bootstrap';
import { getDetallesRetenciones } from '../../../../api/axios';
import ModalDetalleRetenciones from './ModalDetalleRetenciones';
import { toast } from 'react-toastify';
import Liquidacion from '../../../Sellers/Liquidacion';

export default class OrdenesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordenes: props.ordenes,
            seleccionarTodo: false,
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.ordenes !== this.props.ordenes) {


            this.setState({
                ordenes: this.props.ordenes,
            });
        }
    }


    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => {
                if (orden.idOrden === id) {
                    return {
                        ...orden,
                        checked: !orden.checked
                    };
                }
                return orden;
            });
            return { ordenes };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const ordenes = prevState.ordenes.map((orden) => ({
                ...orden,
                checked: seleccionarTodo
            }));
            return { ordenes };
        });

        this.setState({ seleccionarTodo: seleccionarTodo });
    };




    cerrarModal = () => {
        this.setState({ mostrarModal: false, ordenSeleccionada: null });
    };

    render = () => {
        const ordenes = this.props.ordenes;
        const esContaduria = this.props.esContaduria;
        return (
            <>
                {
                    this.props.isLoading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        </div>
                    ) : (
                        ordenes.length > 0 ? (
                            <div className="row justify-content-center align-items-center p-10">
                                <h5 className="col-auto">Ordenes</h5>
                                <div className="list-group-item col-12 animated fadeIn">
                                    <div className="table-responsive card">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col"><small>N° Orden</small></th>
                                                    <th scope="col"><small>Tipo</small></th>
                                                    <th scope="col"><small>Estado</small></th>
                                                    <th scope="col"><small>Fecha</small></th>
                                                    <th scope="col"><small>Importe</small></th>
                                                    <th scope="col"><small>Comisión Neta</small></th>
                                                    <th scope="col"><small>Comisión Total</small></th>
                                                    <th scope="col"><small>Importe Total</small></th>
                                                    <th scope="col"><small>Total Retenciones</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.ordenes.map((orden, i) => (
                                                    <tr key={i} className="hover-background-color">
                                                        <td><span><small>{orden.idOrden}</small></span></td>
                                                        <td><span><small>{orden.tipoPublicacionMostrar}</small></span></td>
                                                        <td><span><small>{orden.estado}</small></span></td>
                                                        <td><span><small>{orden.fechaMostrar}</small></span></td>
                                                        <td><span><small>${orden.totalOrden}</small></span></td>
                                                        <td><span><small>${orden.comisionNeto}</small></span></td>
                                                        <td><span><small>${orden.totalComision}</small></span></td>
                                                        <td><span><small>${orden.importe}</small></span></td>
                                                        <td>
                                                            <span><small>${orden.retencion}</small></span>
                                                            {orden.retencion > 0 /*&& this.props.esContaduria*/ ? (
                                                                <i
                                                                    className="fa fa-clipboard ms-2"
                                                                    aria-hidden="true"
                                                                    onClick={() => this.props.onVerDetalleRetenciones(orden.idOrden, "orden")}

                                                                />
                                                            ) : (
                                                                <i className="fa fa-eye invisible" />
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card">
                                <div className="card-body">
                                    <div className="row justify-content-center align-items-center p-10">
                                        No hay órdenes para esta liquidación
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </>
        );
    }
}